module.exports = __webpack_public_path__ + "img/old.thenews.im.2f9bec82.png";